'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = generateClassName;

var _murmurhash3_gc = require('murmurhash-js/murmurhash3_gc');

var _murmurhash3_gc2 = _interopRequireDefault(_murmurhash3_gc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Generates a class name using murmurhash.
 */
function generateClassName(str, rule, sheet) {
  if (sheet && sheet.options.meta) str += sheet.options.meta;

  var hash = (0, _murmurhash3_gc2['default'])(str);

  // There is no name if `jss.createRule(style)` was used.
  return rule.name ? rule.name + '-' + hash : hash;
}


//////////////////
// WEBPACK FOOTER
// ./~/jss/lib/utils/generateClassName.js
// module id = 313
// module chunks = 0